import { Accordion, AccordionDetails, Typography, useEventCallback } from '@mui/material';
import { memo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { ExpandMore } from '@mui/icons-material';
import { useFormikContext } from 'formik';
import Form from './form';
import { PracticeEditDocumentVM } from 'practice/view-models/practice-edit-document';
import { DocumentiRichiestiVO } from 'shell/models/requested-document';

interface AccordionDocumentProps {
  codeEnte?: string;
  yearId?: string;
  typeRegister?: string;
  progressive?: string;
  disabled?: boolean;
  maxActiveStep: number;
  requestedDocumentResponse?: DocumentiRichiestiVO;
  consensoOspitante?: boolean;
}

const AccordionDocumentComponent = ({
  codeEnte,
  yearId,
  typeRegister,
  progressive,
  disabled = false,
  maxActiveStep,
  requestedDocumentResponse,
  consensoOspitante,
}: AccordionDocumentProps): React.ReactElement => {
  const [open, setOpen] = useState(true);

  const formContext = useFormikContext<PracticeEditDocumentVM>();

  const onChange = useEventCallback(
    (
      key: keyof PracticeEditDocumentVM,
      value: PracticeEditDocumentVM[keyof PracticeEditDocumentVM]
    ) => {
      formContext.setValues({
        ...(formContext.values || {}),
        [key]: value,
      });
    }
  );

  const onChanges = useEventCallback((values: PracticeEditDocumentVM) => {
    formContext.setValues({
      ...(formContext.values || {}),
      ...(values || {}),
    });
  });

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="accordion-attachments-content"
        id="accordion-attachments-header"
        expandIcon={<ExpandMore />}
      >
        <Typography>Documenti</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Form
          onChange={onChange}
          onChanges={onChanges}
          requiredDocuments={requestedDocumentResponse?.documentRichiesti || []}
          values={formContext.values}
          codeEnte={codeEnte}
          yearId={yearId}
          typeRegister={typeRegister}
          progressive={progressive}
          disabled={disabled}
          maxActiveStep={maxActiveStep}
          consensoOspitante={consensoOspitante}
        />
      </AccordionDetails>
    </Accordion>
  );
};

AccordionDocumentComponent.displayName = 'Practice Edit - Form - accordion Document';

const AccordionDocument = memo(AccordionDocumentComponent);

export default AccordionDocument;
